<template>
  <frame-view page="income"></frame-view>
</template>
<script>
import FrameView from './components/FrameView'

export default {
  components: {
    FrameView
  }
}
</script>
